module.exports = __webpack_public_path__ + "static/brain-explosion-333dab27fbe13398f91413db364174cb.gif";